import { trigger, transition, style, animate } from '@angular/animations';

export const Expanding = [
  trigger('expanding', [
      transition(':enter', [
          style({transform: 'translateY(-15px) scaleY(0.2)', minHeight: 0, height: 0, opacity: 0, margin: 0, overflow: 'hidden'}),
          animate('300ms ease', style({transform: 'translateY(0) scaleY(1)', height: '*', margin: '*', opacity: 1}))
      ]),
      transition(':leave', [
          animate('300ms ease', style({transform: 'translateY(-15px) scaleY(0.2)', minHeight: 0, height: 0, opacity: 0, margin: 0}))
      ]),
  ])
];


